module.exports = "/assets/data/64b9dd5fc952f3d3f34963cfab3434a8-SW10.data.json";